
























import { Component, Prop, Vue } from 'vue-property-decorator'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'

interface Option {
  label: string
  value: string | number
}

@Component({
  components: {
    DropdownSelect,
    TextInput,
  },
})
export default class CODFeeInput extends Vue {
  @Prop({ type: Array, default: () => [] }) public options!: Option[]
  @Prop({ type: Object }) public codMultiplyTypeValue!: Option
  @Prop({ type: [String, Number] }) public codFeeValue!: number | string
  @Prop({ type: Boolean, default: false }) public isError!: boolean
  @Prop({ type: Boolean, default: false }) public disabled!: boolean
  @Prop({ type: String }) public type!: string

  get filteredOptions(): Option[] {
    return this.options.filter(
      option => option.value !== this.codMultiplyTypeValue.value
    )
  }

  public onInputType(val: Option): void {
    if (!val) {
      this.$emit('input', this.options[0])
    } else {
      this.$emit('input', val)
    }
  }

  public onInputFee(val: number): void {
    this.$emit('input-fee', val)
  }
}
